<template>
    <g>
        <text text-anchor="end" :transform="transform" :fill="textColor" font-size="14" font-family="Inter, sans-serif">{{formatEuro(value,kerncijfersStore.hasMillions)}}</text>
        <line :x1="x1" :y1="y" :x2="x2" :y2="y" :stroke="strokeColor" stroke-width="1"></line>
    </g>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {useKerncijfersStore} from "./store";
    import tweenValue from "../../../../lib/Tween";

    export default defineComponent({
        name: 'chart-y-axis-separator',
        props: {
            value: {
                type: Number,
                required: true
            },
            y: {
                type: Number,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                tween: {
                    y: this.y
                },
                kerncijfersStore: useKerncijfersStore()
            };
        },
        watch: {
            y: function (val) {
                tweenValue(this.tween, "y", val);
            }
        },
        computed: {
            x1(): number { return this.value === 0 ? -15 : 0 },
            x2(): number { return this.kerncijfersStore.chartWidth },
            transform(): string {
                return `translate(-30,${this.tween.y + 4})`;
            },
            textColor(): string {
                let color = '#161818';
                if (this.value < 0)
                    color = 'red';

                return color;
            },
            strokeColor(): string {
                return this.value === 0 ? '#868686' : '#dee2e6';
            },
        },
        methods: {
            formatEuro(value: number, hasMillions: boolean) {
                let formattedValue = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');

                if (hasMillions) {
                    return formattedValue
                        .replace(/(.+)? 000 000$/, '$1 M')
                        .replace(/^(-)?(\d)00 000$/, '$10,$2 M')
                        .replace(/^(-)?(\d+)(?:\s+)?(\d)00 000$/, '$1$2,$3 M');
                }

                return '€ ' + formattedValue;
            }
        }
    });
</script>